import $ from 'jquery';

var map, search, bounds, infoWindow, url;
var markers = [];

$(function () {
    search = $('.carboncreditsearchpage');
    if (search.length) {
        const API_KEY = "AIzaSyA9xI9GmGxlg44dTE1-EghzrHBjd7FdtVc";
        url = $(search).data('url');

        (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={ });var d=b.maps||(b.maps={ }),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await(a = m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
                    key: API_KEY,
                v: "weekly",
        });
        

        $('.search-form', search).on('change', 'input, select', function () {
            let form = $(this).parents('form').serialize();
            $.ajax({
                url: url + ($('.map-view', search).length ? 'mapSearch' : 'search'),
                data: form,
                success: function (d) {
                    populate(d);
                }
            });
        });

        // handle clicks on map view (in case options have changed)
        $('.view-type.map-link', search).on('click', function (evt) {
            evt.preventDefault();
            let form = $('.search-form', search).serialize();

            window.location = '?' + form + '&mapView=true';
        });

        $('.view-type.list-link', search).on('click', function (evt) {
            evt.preventDefault();
            let form = $('.search-form', search).serialize();

            window.location = '?' + form;
        });

        if ($('.map-view', search).length) { 
            initMap($('.search-form', search));
        }
    }
});

async function initMap(form) {
    const { Map, InfoWindow } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    map = new Map(document.getElementById("map"), {
        zoom: 7,
        mapTypeControl: false,
        mapId: "477df73878258b5"
    });

    bounds = new google.maps.LatLngBounds();
    infoWindow = new InfoWindow();

    infoWindow.addListener("content_changed", () => {
        window.setTimeout(function () { $('.carboncreditcard').foundation(); }, 10);        
    });

    $.ajax({
        url: url + 'mapSearch',
        data: form.serialize(),
        success: function (d) {
            populate(d);
        }
    });
}

function populate(d) {
    if ($('.map-view', search).length) {
        // clear all markers
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers.length = 0;

        for (const card of d.cards) {
            let cardData = $(card).find('.carboncreditcard').data();
            const AdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
                map,
                content: buildCardContent(card),
                position: { lat: cardData.lat, lng: cardData.lon },
                title: $(card).find('.h5').text()
            });

            bounds.extend(AdvancedMarkerElement.position);
            AdvancedMarkerElement.addListener("click", function (evt) {
                toggleCard(AdvancedMarkerElement, card, evt);
            });

            markers[markers.length] = AdvancedMarkerElement;
        }

        map.fitBounds(bounds);
    } else {
        $('.results-page', search).empty().append(d.cards);
        $('.orbit', search).foundation();
        $('.pager.desktop', search).replaceWith(d.pagers[0]);
        $('.pager.mobile', search).replaceWith(d.pagers[1]);
    }

    $('#propertyCountLabel', search).text(d.total + ' project' + (d.total == 1 ? '' : 's') + ' found');
}

function toggleCard(markerView, card, evt) {
    infoWindow.setContent(card);
    infoWindow.open(map, markerView);

    //if (evt.domEvent.target.classList.contains('close')) {
    //    evt.domEvent.cancelBubble = true;
    //    if (markerView.content.classList.contains("highlight")) {
    //        markerView.content.classList.remove("highlight");
    //        markerView.zIndex = null;
    //    }
    //    return;
    //}

    //$('.cc-card').removeClass('highlight');
    //$('.cc-card').parent().parent().css({ 'z-index': 0 });
    //markerView.content.classList.add("highlight");
    //markerView.zIndex = 1;
    //$(markerView.content).foundation();
    
}


function buildCardContent(card) {
    const content = document.createElement("div");
    content.classList.add("cc-card");
    content.innerHTML = `
        
        <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" height="49" width="35" viewBox="0 0 117 187" ><path fill-rule="nonzero" clip-rule="evenodd" fill="#25316A" d="M104.4,77.6l-25.1,55.5l-21.7,45.6h-0.1l-21.6-45.5L10.8,77.6c-6-15.5-4-33,5.3-46.8	c15.4-22.9,46.5-29,69.4-13.5c5.3,3.6,9.9,8.2,13.5,13.6C108.4,44.7,110.4,62.1,104.4,77.6L104.4,77.6z M57.6,3.5"/>	<path fill-rule="evenodd" clip-rule="evenodd" fill="#25316A" d="M104.4,77.6l-25.1,55.5l-21.7,45.6h-0.1l-21.6-45.5L10.8,77.6c-6-15.5-4-33,5.3-46.8	c15.4-22.9,46.5-29,69.4-13.5c5.3,3.6,9.9,8.2,13.5,13.6C108.4,44.7,110.4,62.1,104.4,77.6L104.4,77.6z M57.6,3.5	c-18.4,0-35.6,9.1-45.9,24.4C1.4,43.2-0.8,62.5,5.9,79.7l25.2,55.8l21.7,45.7c1.3,2.6,4.6,3.7,7.2,2.3c1-0.5,1.8-1.3,2.3-2.3	l21.7-45.6l25.2-55.8c6.7-17.2,4.5-36.5-5.8-51.8C93.2,12.6,76,3.5,57.6,3.5z"/>	<path class="st2" fill="#fff" d="M59.8,100.5c-3.4,0-6.6,0-9.8,0c2.9-7.6,2.4-13.6-4.2-18.1c-2.8-1.9-5.4-3.7-9.2-3.4		c-4.9,0.3-9.3-3.8-10.4-8.7c-1.1-4.9,1.2-9.8,5.6-12.2c0.7-0.4,1.5-0.7,2.3-1.1c-2.2-4.1-2.1-8,1.1-11.5c3.1-3.3,6.9-3.6,11.2-1.9		c1.5-3.3,4-5.7,7.7-6.2c3.7-0.5,6.6,1,8.9,3.8c5.8-1.7,10.7-0.4,12.3,4.1c1.2,3.5,3.2,6.2,5.3,9.1c1.2,1.6,2.3,3.2,4,4.5		c3.2,2.5,4.1,7,2.5,10.5c-1.9,4-5.8,5.8-9.9,5c-3.1,2.4-5.7,4.4-8.4,6.4c-0.7,0.5-1.5,0.8-2.2,1.1c-10.2,5.1-8.1,5-7.9,15.1		C58.6,98.2,59.3,99.1,59.8,100.5z M58.5,81.3c0.2,0.2,0.4,0.3,0.7,0.5c4.1-3,9.4-4,13-8.2c-3.1-0.7-5.7-1.3-8.9-2		C61.7,74.7,60.1,78,58.5,81.3z M51.4,82.1c0.2-5.4-1.2-8.5-4.2-9.1c-1,1.3-2,2.5-3,3.8C46.6,78.6,48.9,80.3,51.4,82.1z M53.8,73.9		c0.5,1.8,0.9,3.5,1.4,5.7c1.1-2.5,2-4.6,3.1-7C56.6,73.1,55.3,73.5,53.8,73.9z"/></svg>
            <span class="show-for-sr">Carbon credit</span>
        </div>
        `;

    return content;
    //<div class="details hide">` + card + `</div>
    //<button aria-label="close" title="Close" class="close"><span style="mask-image: url(&quot;data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M19%206.41L17.59%205%2012%2010.59%206.41%205%205%206.41%2010.59%2012%205%2017.59%206.41%2019%2012%2013.41%2017.59%2019%2019%2017.59%2013.41%2012z%22/%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22none%22/%3E%3C/svg%3E&quot;);"></span></button>
}